import MobileQuickSignInComponent from './MobileQuickSignInContainer';

export default MobileQuickSignInComponent;